import React, { FC } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import PaginationButtons from '../../../../PaginationButtons'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import { Location } from '@teschglobal/tg-fhir-react-components/dist/types'
import { LocationTable } from '@teschglobal/tg-fhir-react-components'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import FhirLoader from '../../../../FhirLoader'

interface LocationListProps {
    locations: ProviderResponse<Location>
    clickViewDataLink: (location: Location) => void
    isFetching: boolean
    isSuccess: boolean
    searchProviderResource: { searchTerms: string, resource: string }
    clearForm: () => void
    newSearch: () => void
    updateSearchTerms: (e: React.ChangeEvent<HTMLInputElement>) => void
    totalPages: number;
    currentPage: number;
    handleChangePage: (page: number) => void;
}

const LocationList: FC<LocationListProps> = ({ locations, clickViewDataLink, isFetching, isSuccess, searchProviderResource, clearForm, newSearch, updateSearchTerms, totalPages, currentPage, handleChangePage }) => {

    const handleNewSearch = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        newSearch()
    }

    const { data: environment } = useEnvironment()
    const rows: Location[] = locations?.data ?? []

    return (
        <>
            <h3>Location</h3>
            <Form noValidate className="d-flex align-items-center" onSubmit={handleNewSearch} role='form' aria-label='Search Location'>
                <Form.Group className="d-flex align-items-center me-3 mb-0">
                    <Form.Label htmlFor='searchLocation' className="mb-0 me-2 text-nowrap">Search by Location Name</Form.Label>
                    <Form.Control
                        id='searchLocation'
                        type="text"
                        name="keyword"
                        placeholder="Name"
                        value={searchProviderResource.searchTerms}
                        onChange={updateSearchTerms}
                    />
                </Form.Group>

                <Button variant="primary" className="btn-primary-custom" type="submit" id="searchButton">
                    Search
                </Button>
                <Button variant="primary-outline" type="reset" onClick={clearForm} id="clearButton">
                    Clear
                </Button>
            </Form>
            <hr />
            {isFetching ? (
                <FhirLoader message='Loading...' />
            ) : (
                <>
                    {
                        locations?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <span role="status" aria-live="polite">{locations?.total.toLocaleString()} record(s) found</span>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                    <LocationTable
                        locations={rows}
                        onRowLinkClick={clickViewDataLink}
                    />
                    {
                        locations?.total > 0 && environment?.includeTotalInFHIRRequest && (
                            <div className='my-3 fw-bold'>
                                <PaginationButtons
                                    totalPages={totalPages}
                                    currentPage={currentPage}
                                    handleChangePage={handleChangePage}
                                />
                            </div>
                        )
                    }
                </>
            )}
        </>
    )
}

export default LocationList